import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithBody } from "@utils/http-util";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { MessageTemplate } from "@idw-types/data/message-template";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { MessageTemplateTypes } from "@enums/message-template-types";
import { resources } from "@constants/hardcoded-strings";

type CreateMessageTemplateRequestResponse = {
    response: MessageTemplate;
};

export const createMessageTemplateRequest = async (
    template: string,
    name: string,
    companyId: string,
    languages: Partial<MultiLanguageWrapper<string>>,
    sender: string,
    type: string,
): Promise<GenericNetworkResponse<CreateMessageTemplateRequestResponse>> => {
    const route = apiRoutes.axnadminCore.data.messageTemplate;
    const languagesString = JSON.stringify(languages);
    if (type === MessageTemplateTypes.SMS) {
        sender = resources.pages.messageTemplateDetails.tabs.variables.defaultSMSSender.title; // Default sender for SMS templates
    }
    const body: Partial<MessageTemplate> = {
        template,
        name,
        organizationID: companyId,
        languages: languagesString,
        sender,
        type,
        status: EntityStatusTypes.ACTIVE,
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.POST, route, body);
    return { data, error, body };
};